<div class="container">
  @if(busy()){
  <div class="busy">
    <mat-spinner></mat-spinner>
    Processing . . .
  </div>
  }
  @if(messages().length > 0){
  <div class="messages-container">

    <div class="messages">
      <p class="center">If you have any questions or issues, please email <a
          [href]="companySite().helpLink">{{companySite().helpLink}}.</a></p>
      <div class="float-right">
        <mat-icon (click)="applicationService.clearMessages()"
          (keydown)="applicationService.clearMessages()">close</mat-icon>
      </div>
      @for(message of messages(); track message){
      <div class="message" [ngClass]="message.type">
        @if(message.type === MessageType.ERROR){
        <mat-icon>error</mat-icon>
        }
        @if(message.type === MessageType.INFO){
        <mat-icon>info</mat-icon>
        }
        @if(message.type === MessageType.SUCCESS){
        <mat-icon>check_circle</mat-icon>
        }
        @if(message.type === MessageType.WARNING){
        <mat-icon>warning</mat-icon>
        }
        @if (hasCustomerServiceEmail(message.message)) {
          {{getMessageBeforeCustomerServiceEmail(message.message)}}<a [href]="CUSTOMER_SERVICE_MAILTO">{{CUSTOMER_SERVICE_EMAIL}}</a>{{getMessageAfterCustomerServiceEmail(message.message)}}
        } @else {
          {{message.message}}
        }
      </div>
      }
    </div>
  </div>

  }

  <router-outlet></router-outlet>
</div>
